/* eslint-disable kf/trans-tag-string */
import React from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./styles.css";

export class ErrorBoundary extends React.Component {
  static propTypes = {
    /**
     * Children covered by the error boundary
     */
    children: PropTypes.node,
    /**
     * Event handler when error occurs
     */
    onError: PropTypes.func,
    fallBackComponent: PropTypes.node
  };

  static defaultProps = {
    onError: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, errorInfo) {
    //log the error;
    console.error("ErrorBoundary::Error ", error);
    this.props.onError({ error, errorInfo });
    this.setState({ error });

    //componentStack is what react gives the React component tree from the root
    //to where the error occured.
    sentryCaptureException(error, {
      captureContext: {
        contexts: {
          react: { componentStack: errorInfo.componentStack }
        }
      }
    });
  }

  reloadBrowser = () => {
    window.location.reload();
  };

  render() {
    return this.state.error ? (
      <React.Fragment>
        {this.props.fallBackComponent ? (
          this.props.fallBackComponent
        ) : (
          <p className={styles.text}>
            There was an error{" "}
            <button
              className={`${styles.link}`}
              onClick={(e) => {
                e.preventDefault();
                this.reloadBrowser();
              }}
            >
              Reload
            </button>
          </p>
        )}
      </React.Fragment>
    ) : (
      this.props.children
    );
  }
}

export const sentryCaptureException = async (error, errorInfo) => {
  try {
    const Sentry = await import("@sentry/react");
    Sentry.captureException(error, errorInfo);
  } catch (err) {
    console.info("Failed to load sentry in error boundry");
  }
};
